export default "__VITE_ASSET__BpOXJ1Se__"